<template>
  <el-dropdown
    trigger="click"
    placement="bottom-start"
  >
    <span class="el-dropdown-link">
      <Promised
        :promise="breadcrumbs[breadcrumbs.length - 1]"
        :pending-delay="0"
      >
        <template v-slot:pending>
          <font-awesome-icon
            :icon="['fal', 'circle-notch']"
            spin
          />
        </template>

        <template v-slot="data">
          {{ data.name | truncate(10) }}<i class="el-icon-arrow-down el-icon--right" />
        </template>
      </Promised>
    </span>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(breadcrumb, index) in reversedBreadcrumbs"
        :key="index"
      >
        <Promised
          v-if="index > 0"
          :promise="breadcrumb"
          :pending-delay="0"
        >
          <template v-slot:pending>
            <font-awesome-icon
              :icon="['fal', 'circle-notch']"
              spin
            />
          </template>

          <template v-slot="data">
            <router-link :to="data.route">
              {{ data.name | truncate(15) }}
            </router-link>
          </template>
        </Promised>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Promised } from 'vue-promised'

export default {
  components: { Promised },
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  computed: {
    reversedBreadcrumbs () {
      return this.$props.breadcrumbs.slice().reverse()
    }
  }
}
</script>
